// src/core/constants/permissions.ts
export const PERMISSIONS = {
  // User
  CREATE_USER: 'create_user',
  UPDATE_USER: 'update_user',
  DELETE_USER: 'delete_user',
  VIEW_USER: 'view_user',
  LIST_USER: 'list_user',

  // Company Users
  LIST_COMPANY_USER: 'list_company_user',
  VIEW_SHARED_CITY_CATALOG: 'view_shared_city_catalog',
  MANAGE_SHARED_CITY_CATALOG: 'manage_shared_city_catalog',
  VIEW_SHARED_PRODUCT_CATALOG: 'view_shared_product_catalog',
  MANAGE_SHARED_PRODUCT_CATALOG: 'manage_shared_product_catalog',
  VIEW_USER_PRINT_STAMPS: 'view_user_print_stamps',

  // Remittance
  CREATE_REMITTANCE: 'create_remittance',
  UPDATE_REMITTANCE: 'update_remittance',
  LIST_REMITTANCE: 'list_remittance',
  VIEW_REMITTANCE: 'view_remittance',
  REMITTANCE_INTRODUCTION_LETTER: 'remittance_introduction_letter',
  CHANGE_STATE_REMITTANCE: 'change_state_remittance',
  MANAGE_REMITTANCE_WAYBILL_SETTINGS: 'manage_remittance_waybill_settings',

  // Role
  LIST_ROLE: 'list_role',
  VIEW_ROLE: 'view_role',
  CREATE_ROLE: 'create_role',
  UPDATE_ROLE: 'create_role',
  DELETE_ROLE: 'delete_role',

  // Financial Coefficient
  LIST_FINANCIAL_COEFFICIENT: 'list_financial_coefficient',
  MANAGE_FINANCIAL_COEFFICIENT: 'manage_financial_coefficient',
  LIST_FINANCIAL_COEFFICIENT_DESCRIPTIONS: 'financial_coefficient_descriptions',
  CREATE_FINANCIAL_COEFFICIENT: 'create_financial_coefficient',
  UPDATE_FINANCIAL_COEFFICIENT: 'update_financial_coefficient',

  // Bill Loading
  LIST_BILL_LOADING: 'list_bill_loading',
  CREATE_BILL_LOADING: 'create_bill_loading',
  UPDATE_BILL_LOADING: 'update_bill_loading',
  VIEW_BILL_LOADING: 'view_bill_loading',
  ROADWAY_REGISTER_BILL_LOADING: 'roadway_register_bill_loading',
  REGISTER_MANUAL_BILL_LOADING_TRACKING_CODE: 'register_manual_bill_loading_tracking_code',
  CANCEL_BILL_LOADING: 'cancel_bill_loading',
  CONVERT_BILL_LOADING_TO_CANCELED: 'convert_bill_loading_to_canceled',
  UPDATE_RECIEVED_MONEY_BILL_LOADING: 'update_recieved_money_bill_loading',
  WAYBILL_SEND_CHECK: 'waybill_send_check',
  WAYBILL_REJECT_ADMIN: 'waybill_reject_admin',
  DELETE_BILL_LOADING: 'delete_bill_loading',
  REFERENCE_BILL_LOADING: 'reference_bill_loading',

  // Driver
  CREATE_DRIVER: 'create_driver',
  UPDATE_DRIVER: 'update_driver',
  VIEW_DRIVER: 'view_driver',
  LIST_DRIVER: 'list_driver',
  CHANGE_STATUS_DRIVER: 'change_status_driver',
  DELETE_DRIVER: 'delete_driver',

  // CAR
  CREATE_CAR: 'create_car',
  UPDATE_CAR: 'update_car',
  DELETE_CAR: 'delete_car',
  VIEW_CAR: 'view_car',
  LIST_CAR: 'list_car',

  // Insurance Contract
  LIST_INSURANCE_CONTRACT: 'list_insurance_contract',
  CREATE_INSURANCE_CONTRACT: 'create_insurance_contract',
  UPDATE_INSURANCE_CONTRACT: 'update_insurance_contract',
  VIEW_INSURANCE_CONTRACT: 'view_insurance_contract',
  DELETE_INSURANCE_CONTRACT: 'delete_insurance_contract',

  // Waybill_number
  LIST_WAYBILL_NUMBER: 'list_waybill_number',
  CREATE_WAYBILL_NUMBER: 'create_waybill_number',
  UPDATE_WAYBILL_NUMBER: 'update_waybill_number',
  VIEW_WAYBILL_NUMBER: 'view_waybill_number',
  DELETE_WAYBILL_NUMBER: 'delete_waybill_number',
  CHANGE_STATUS_WAYBILL_NUMBER: 'change_status_waybill_number',
  RELEASE_WAYBILL_NUMBER_RESERVATION: 'release_waybill_number_reservation',

  // Company
  CREATE_COMPANY: 'create_company',
  UPDATE_COMPANY: 'update_company',
  VIEW_COMPANY: 'view_company',
  LIST_COMPANY: 'list_company',
  DELETE_COMPANY: 'delete_company',

  // Permission
  CREATE_PERMISSION: 'create_permission',
  UPDATE_PERMISSION: 'update_permission',
  VIEW_PERMISSION: 'view_permission',
  LIST_PERMISSION: 'list_permission',
  DELETE_PERMISSION: 'delete_permission',

  // Transceiver
  LIST_TRANSCEIVER: 'list_transceiver',
  CREATE_TRANSCEIVER: 'create_transceiver',
  UPDATE_TRANSCEIVER: 'update_transceiver',
  DELETE_TRANSCEIVER: 'delete_transceiver',

  // Branch
  LIST_BRANCH: 'list_branch',
  VIEW_BRANCH: 'view_branch',
  VIEW_MANAGER_BRANCHES: 'view_manager_branches',
  CREATE_BRANCH: 'create_branch',
  UPDATE_BRANCH: 'update_branch',
  DELETE_BRANCH: 'delete_branch',

  // Office
  LIST_OFFICE: 'list_office',
  VIEW_MANAGER_OFFICES: 'view_manager_offices',
  VIEW_OFFICE: 'view_office',
  CREATE_OFFICE: 'create_office',
  UPDATE_OFFICE: 'update_office',
  DELETE_OFFICE: 'delete_office',

  // Certificate
  LIST_CERTIFICATE: 'list_certificate',
  CREATE_CERTIFICATE: 'create_certificate',
  UPDATE_CERTIFICATE: 'update_certificate',
  DELETE_CERTIFICATE: 'delete_certificate',
  VIEW_CERTIFICATE: 'view_certificate',

  // Bank Account
  LIST_BANK_ACCOUNT: 'list_bank_account',
  WITHDRAW_BANK_ACCOUNT: 'withdraw_bank_account',
  CREATE_BANK_ACCOUNT: 'create_bank_account',
  UPDATE_BANK_ACCOUNT: 'update_bank_account',
  DELETE_BANK_ACCOUNT: 'delete_bank_account',
  CHANGE_STATUS_BANK_ACCOUNT: 'change_status_bank_account',
  ASSIGN_BANK_ACCOUNT: 'assign_bank_account',

  // Compatibility for unlinked legacy source files; these permissions are no longer seeded.
  LIST_CREDIT_RECIPIENT: 'list_credit_recipient',
  CREATE_CREDIT_RECIPIENT: 'create_credit_recipient',
  SETTLE_CREDIT_RECIPIENT: 'settle_credit_recipient',
  VIEW_ALL_CREDIT_RECIPIENT: 'view_all_credit_recipient',

  // Financial-detail waybill
  CREATE_FINANCIAL_DETAIL_BILL_LOADING: 'create_financial_detail_billloading',

  // Waybill Payment
  LIST_BILL_LOADING_PAYMENT: 'list_bill_loading_payment',
  CREATE_BILL_LOADING_PAYMENT: 'create_bill_loading_payment',

  // Customer
  LIST_CUSTOMER: 'list_customer',
  MANAGE_CUSTOMERS: 'manage_customers',
  MANAGE_SECONDARY_CUSTOMER_DEBT: 'manage_secondary_customer_debt',
  VIEW_ISSUER_DEBT_ALLOCATIONS: 'view_issuer_debt_allocations',
  REVIEW_WAYBILL_DEBT_ASSIGNMENTS: 'review_waybill_debt_assignments',
  CREATE_CUSTOMER: 'create_customer',
  UPDATE_CUSTOMER: 'update_customer',
  CHANGE_STATUS_CUSTOMER: 'change_status_customer',

  // Customer payment
  LIST_CUSTOMER_PAY: 'list_customer_pay',
  CREATE_CUSTOMER_PAY: 'create_customer_pay',

  // Accounting
  VIEW_ACCOUNTING: 'view_accounting',
  VIEW_FINANCIAL_POSITION: 'view_financial_position',
  VIEW_DASHBOARD_CHARTS: 'view_dashboard_charts',
  MANAGE_ACCOUNTING_ACCOUNTS: 'manage_accounting_accounts',
  MANAGE_ACCOUNTING_PERIODS: 'manage_accounting_periods',
  CLOSE_ACCOUNTING_PERIOD: 'close_accounting_period',
  REOPEN_ACCOUNTING_PERIOD: 'reopen_accounting_period',
  REVERSE_ACCOUNTING_ENTRY: 'reverse_accounting_entry',
  POST_WAYBILL_ACCOUNTING: 'post_waybill_accounting',
  APPROVE_BILL_LOADING_PAYMENT: 'approve_bill_loading_payment',
  REJECT_BILL_LOADING_PAYMENT: 'reject_bill_loading_payment',
  CREATE_MANUAL_ADJUSTMENT: 'create_manual_adjustment',
  APPROVE_MANUAL_ADJUSTMENT: 'approve_manual_adjustment',
  APPROVE_DRIVER_PAYMENT: 'approve_driver_payment',
  REFUND_BILL_LOADING_PAYMENT: 'refund_bill_loading_payment',
  CHARGEBACK_DRIVER_PAYMENT: 'chargeback_driver_payment',
  MANAGE_ISSUER_FINANCIAL_STATUS: 'manage_issuer_financial_status',
  LIST_POS_DEVICE: 'list_pos_device',
  ASSIGN_POS_DEVICE_USERS: 'assign_pos_device_users',
  VIEW_SUSPICIOUS_WAYBILLS: 'view_suspicious_waybills',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];
